import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

// TODO: this file should be cleaned up, and should not relay on so much nested
// fragments

const DOC = gql`
  ${fragments.record.DOC}
  query GeneralLedger(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $skip: Int
    $sortBy: GeneralLedgerSortInput
    $quantity: Int
    $searchTerm: String
    $filter: GeneralLedgerFilterInput
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                glRecords(
                  skip: $skip
                  quantity: $quantity
                  sortBy: $sortBy
                  searchTerm: $searchTerm
                  filter: $filter
                ) {
                  ...FragmentGeneralLedgerRecord
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.GeneralLedgerQuery,
    ents.extra.rate.gl.Record[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'rate',
              graphql.transformers.OUT.select(
                'glRecords',
                graphql.transformers.OUT.list(fragments.record.TRANSFORMER, {
                  onNullish: 'remove',
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.GeneralLedgerQuery,
  ents.extra.rate.gl.Record[],
  graphql.schema.GeneralLedgerQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
